import { FC } from 'react';
import styles from './index.module.less';
import Link from '@base/lib/ThemeLink';
import { IProdTitleProps, IProdNameProps } from './interface';
import { getVariantTagType } from '@base/product/utils';
import ProdShare from '@base/product/ProdShare';
import cn from 'classnames';

const ProdName: React.FC<IProdNameProps> = props => {
    const { shownVariant } = props;

    return <h1 tabIndex={0}>{shownVariant.name || shownVariant.productName}</h1>
}

export const ProdTitle: FC<IProdTitleProps> = props => {
    const { shownVariant, isQuickView, canJump, ...rest } = props;

    const nameProps: IProdNameProps = {
        shownVariant,
        tagType: getVariantTagType(shownVariant),
    }

    return (
        <div className={styles.title} {...rest}>
            <div className={cn(styles.name, 'g-name')}>
                <div>
                    {isQuickView && canJump ? (
                        <Link href={shownVariant.url}>
                            <a target="_blank" rel="noopener">
                                <ProdName {...nameProps}/>
                            </a>
                        </Link>
                    ) : (
                        <ProdName {...nameProps}/>)
                    }
                </div>
                {process.env.NEXT_PUBLIC_TERMINAL !== 'm' && (
                    <ProdShare shownVariant={shownVariant} />
                )}
            </div>
        </div>
    )
};
